import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { ComponentType } from "../../../../modules/manage-components/manage-components.model";
import { ManageComponentsService } from "../../../../modules/manage-components/manage-components.service";
import { SetupUndercarriageService } from "../../../../modules/setup-undercarriage";
import { Make, SystemType } from "../../../../entities/global/model";
import {
  ChildComponent,
  CompartDto,
  ComponentPosition,
  AddComponentRequest,
} from "../../models/manage-equipment.model";
import { ManageEquipmentService } from "../../manage-equipment.service";
import { componentTypes } from "../../../../shared/enums/allEnums";
import { SystemModelTemplate, SystemSetup } from "../../../../entities";
import { NotificationsService } from "angular2-notifications";
import { AddComValidationRequest, AddNewCompValidationViewModel } from "../../models/manage-equipment.model";
import { AddNewComponentValidationComponent } from "../add-new-component/add-new-component-validation/add-new-component-validation";
import { Side, UCSystemType } from "../../../interpretation/models/interpretation.model";
import { DatePipe } from '@angular/common';

@Component({
  selector: "app-add-new-component",
  templateUrl: "./add-new-component.html",
  styleUrls: ["./add-new-component.scss"],
})
export class AddNewComponentComponent implements OnInit {
  ComponentType: any;
  Part: any;
  Brand: string;
  Position: number;
  componentTypeList: ComponentType[] = [];
  availableComponentMakes: Make[] = [];
  compartList: CompartDto[] = [];
  SelectedMakeId: number | null = null;
  makeList: any[] = [];
  componentTypes = componentTypes;
  componentPositionList: ComponentPosition[] = [];
  systemTemplate: SystemModelTemplate[] = [];
  isPositionDisabled: boolean = false;
  childCompoentList: ChildComponent[] = [];
  isChild: boolean = false;
  componentPositionSide: any[] = [];
  checked: boolean = false; // For child component checkbox
  selectedCompartId: any;
  EquipmentComponent: any;
  parentPosition: number = 1; // For parent position
  isSaveEnabled: boolean = false;
  postionIncrement: number = 0;
  newCompartId: number = 0;
  systemType: number = 0;
  isReplaceExistingTab: boolean = false;
  isEqBarType: boolean = false;

  selectedToeOut: number;
  selectedConditon: string;
  budgetLife: number = 0;
  cmu: number = 0;
  cost: number;
  isEqualiserBar: boolean = false;
  showValidation = false;
  brandId: number;
  jobsiteId: number;
  modelId: number;
  famId: number;
  isSaving = false;
  equipmentSetupDate: Date;
  equipmentSetupDateString: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddNewComponentComponent>,
    private _componentservice: ManageComponentsService,
    private _setupService: SetupUndercarriageService,
    private _manageEquipmentService: ManageEquipmentService,
    private _notify: NotificationsService,
    private dialog: MatDialog,
    private datePipe: DatePipe
  ) {}
  ngOnInit(): void {
    this.isReplaceExistingTab = this.data.IsReplaceExistingTab;
    this.isEqualiserBar = this.data.isEqualiserBar;
    this.brandId = this.data.BrandId;
    this.jobsiteId = this.data.jobsiteId;
    this.modelId = this.data.modelId;
    this.famId = this.data.famId;
    this.getSystemTemplate();
    this.getComponentType();
    if(this.isEqualiserBar)
      this.getEquipmentSetupDate();
    console.log("save", this.isSaveEnabled);
  }

  getEquipmentSetupDate(){
    this._manageEquipmentService.getEquipmentDateAtSetup(this.data.EquipmentId).subscribe((result) => {
      this.equipmentSetupDate = result;
      console.log(this.equipmentSetupDate);
    });
  }
  getComponentType() {
    this._componentservice.getComponentType().subscribe((result) => {
      this.componentTypeList = result;
      if (this.isEqualiserBar) {
        const equaliserBarType = this.componentTypeList.find((x) => x.TypeId === "EqualiserBar");
        this.ComponentType = equaliserBarType?.Id;
        this.isEqBarType = true;
        this.getEquipmentComponent();
        //this.brandId = 
      }
    });
  }

  changeComponentType(event: any) {
    this.ComponentType = event.value;
    const selectedType = this.componentTypeList.find((x) => x.Id === event.value);
    this.isEqBarType = selectedType?.TypeId == "EqualiserBar" ? true : false;
    this.getEquipmentComponent();
    //this.getCompartList();
    this.loadComponentPositions(this.data.EquipmentId, this.ComponentType);
  }

  getEquipmentComponent() {
    this._manageEquipmentService
      .GetEquipmentComponent(this.ComponentType, this.data.EquipmentId)
      .subscribe((result) => {
        this.EquipmentComponent = result.Data[0]?.CompartId;
        console.log(this.EquipmentComponent);
        this.getCompartList();
      });
  }

  getCompartList() {
    this._manageEquipmentService
      .getCompartList(this.ComponentType, this.data.EquipmentId, this.EquipmentComponent ?? 0)
      .subscribe((result) => {
        this.compartList = result.Data;
        console.log('this.compartList', this.compartList);
        if (
          this.ComponentType == 230 ||
          this.ComponentType == 231 ||
          this.ComponentType == 232
        ) {
          this.selectedCompartId = this.compartList[0]?.CompartId || null;
        } else {
          this.selectedCompartId = this.EquipmentComponent;
            // this.compartList.filter(
            //   (x) => x.CompartId == this.EquipmentComponent
            // )[0]?.CompartId || null;
          console.log(this.selectedCompartId);
        }

        this.getChildComponent();
        this.getBrandList();
      });
  }

  changePartNumber(event: any) {
    this.selectedCompartId = event.value;
    this.getChildComponent();
    this.getBrandList();
  }

  // getChildComponent() {
  //   this._manageEquipmentService
  //     .GetChildComponent(this.selectedCompartId, this.data.EquipmentId)
  //     .subscribe((result) => {
  //       this.childCompoentList = result.Data;
  //       if (this.childCompoentList.length > 0) {
  //         this.isChild = true;
  //         this.isSaveEnabled = !this.isChild || this.childCompoentList?.some((c) => c.IsChild);
  //         console.log('save', this.isSaveEnabled);
  //       } else {
  //         this.isChild = false;
  //       }
  //     });
  // }
  getChildComponent() {
    if (this.selectedCompartId) {
      this._manageEquipmentService
        .GetChildComponent(this.selectedCompartId, this.data.EquipmentId, this.parentPosition)
        .subscribe((result) => {
          this.childCompoentList = (result.Data || []).map((c) => ({
            ...c,
            UserSelectable: !c.IsChild, 
          }));
          this.isChild = this.childCompoentList.length > 0;
          this.isSaveEnabled = !this.isChild || this.childCompoentList.some((c) => c.IsChild && c.UserSelectable);
        });
    }
    
  }

  get canSave(): boolean {
    return (
      !!this.ComponentType &&
      !!this.selectedCompartId &&
      !!this.SelectedMakeId &&
      // (!this.isEqBarType || !!this.selectedConditon) &&
      this.isSaveEnabled
    );
  }

  onCheckboxChange(event: any, compartId: number): void {
    console.log(event);
    this.checked = event.checked;
    this.selectedCompartId = compartId;
    this.isSaveEnabled = this.childCompoentList.some(c => c.IsChild && c.UserSelectable);
    console.log("SAVE", this.isSaveEnabled);
  }
  //Setup UC
  getBrandList() {
    if (this.selectedCompartId) {
      const brand = this.compartList.find(
        (x) => x.CompartId === this.selectedCompartId
      ).Brand;
      this._componentservice.getComponentMakeList().subscribe((result) => {
        this.makeList = result;
        const matchedMake = this.makeList.find((m) => m.Name === brand);
        if (matchedMake) {
          this.SelectedMakeId = matchedMake.Id;
        } else {
          this.SelectedMakeId = null;
        }
      });
    }
  }
  //SetupComponent
  // getBrandList() {
  //   const brand = this.compartList.find(x => x.CompartId === this.selectedCompartId).Brand;
  //   this._setupService.getComponentMakeList().subscribe((result) => {
  //     this.availableComponentMakes = result;
  //     const matchedMake = this.availableComponentMakes.find(
  //       (m) => m.Title === brand
  //     );
  //     if (matchedMake) {
  //       this.SelectedMakeId = matchedMake.Id;
  //     } else {
  //       this.SelectedMakeId = null;
  //     }
  //   });
  // }
  brandSelected(event: any) {
    if (!event.value) return;
    const selected = this.availableComponentMakes.find(
      (m) => m.Id === event.value
    );
  }
  onNoClick() {
    this.dialogRef.close(false);
  }

  loadComponentPositions(equipmentId: number, compartTypeId: number) {
    this._manageEquipmentService
      .GetComponentPosition(equipmentId, compartTypeId)
      .subscribe({
        next: (response) => {
          if (response.Status === 1 && response.Data) {
            this.componentPositionList = response.Data;
            this.componentPositionSide = this.componentPositionList.filter(
              (p) => p.Side === 1
            );
            console.log("Component Position", this.componentPositionList);
            //this.postionIncrement = this.componentPositionList.filter(x => x.Side === 1)[0].Pos;
            // Find max position
            this.postionIncrement = Math.max(...this.componentPositionSide.map(x => x.Pos));
            // const matchingTemplate = this.systemTemplate.find(
            //   (t) => t.CompartTypeId === compartTypeId
            // );

            // if (matchingTemplate) {
            //   const maxAllowed = matchingTemplate.Max;
            //   const sideOnePositions = this.componentPositionList.filter(p => p.Side === 1);
            //   const currentCount = sideOnePositions.length;

            //   if (currentCount < maxAllowed) {
            //     const highestPos = sideOnePositions.reduce((max, item) => item.Pos > max ? item.Pos : max, 0);
            //     this.componentPositionList.push({
            //       Pos: highestPos + 1,
            //       Side: 1
            //     });
            //   }

            //   this.isPositionDisabled = false;
            // } else {
            //   this.isPositionDisabled = false;
            // }
          } else {
            console.error("Failed to load positions:", response.Message);
          }
        },
        error: (err) => {
          console.error("API error:", err);
        },
      });
  }
  getSystemTemplate() {
    this.systemTemplate = [];
    this._setupService
      .GetTemplateForEquipment(this.data.EquipmentId)
      .subscribe((template) => {
        this.systemTemplate.push(...template);
        console.log("System Template:", this.systemTemplate);
      });
  }

  onPositionSelected(event: any) {
    this.parentPosition = event.Pos;
    if (this.selectedCompartId) {
      this.getChildComponent();
    }
    console.log("Selected Position:", this.parentPosition);
  }

  private updateSaveEnabled() {
    const mustHaveParent =
      this.isChild &&
      this.childCompoentList?.length &&
      ![230, 231, 232, 236].includes(this.ComponentType);

    this.isSaveEnabled =
      (!this.isChild ||
        this.childCompoentList.some(c => c.IsChild && c.UserSelectable)) &&
      (!mustHaveParent || !!this.Position);
  }

  onSave() {
    this.showValidation = true;

    this.isSaving = true;
    const mustHaveParent = this.isChild && this.childCompoentList?.length 
      && ![230, 231, 232, 236].includes(this.ComponentType);

    if (mustHaveParent && !this.Position) {
      this.isSaving = false;
      this._notify.warn('Please select a Parent Position.');
      return;
    }

    if (this.ComponentType == 230 || this.ComponentType == 231 || this.ComponentType == 232 || this.ComponentType == 240)
      this.systemType = UCSystemType.Chain;
    else if (this.isEqBarType)
      this.systemType = UCSystemType.EqualiserBar;
    else
      this.systemType = UCSystemType.Frame;
    const validation: AddComValidationRequest = {
      EquipmentId: this.data.EquipmentId,
      SystemTypeId: this.systemType
    };

    this._manageEquipmentService.addNewComponentValidation(validation).subscribe({
      next: (res) => {
        if (res?.Status === 1) {
          if(res.Data?.length > 0){
            this.isSaving = false;
            this.openWarningPopup(res.Data);
          } else {
            this.onValidate();
          }
        } else{
          this.isSaving = false;
          console.error('Error', res.Message);
          this._notify.error(res.Message);
        }
      },
      error: (err) => {
        this.isSaving = false;
        this._notify.error('Something went wrong while saving.');
        console.error(err);
      }
    })
  }

  openWarningPopup(res: AddNewCompValidationViewModel[]){
    const dialogRef = this.dialog.open(AddNewComponentValidationComponent, {
      disableClose: true,
      maxHeight: '50vw',
      width: '1032px',
      data: {
        Data: res,
        IsReplaceExistingTab: this.isReplaceExistingTab
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result)
        this.onValidate();
    });
  }

  onValidate() {
    // Only Equaliser Bar requires creating a system first
    if (!this.isEqBarType) {
      this.addComponent();
      return;
    }

    const sys = new SystemSetup();
    const setupDate = new Date(this.equipmentSetupDate);
    sys.Id = 0;
    sys.BudgetLife = this.budgetLife;
    sys.EquipmentId = this.data.EquipmentId;
    sys.HoursAtInstall = this.cmu;
    sys.Cost = this.cost;
    sys.InstallOnEquipment = true;
    sys.InstallationDate = setupDate;
    sys.InstallationDate_ = this.getFormatedDate(setupDate);
    sys.JobsiteId = this.jobsiteId;
    sys.PMUAtInstall = 0;
    sys.PropelAtInstall = 0;
    sys.SetupDate = setupDate;
    sys.Side = Side.Unknown;
    sys.SmuAtInstall = 0;
    sys.Type = SystemType.EqualiserBar;
    sys.Family.Id = this.famId;
    sys.Model.Id = this.modelId;
    sys.Make = this.makeList.find(m => m.Id === this.SelectedMakeId) ?? new Make();
    this._setupService.submit2SystemsInInventory([sys]).subscribe({
      next: (result) => {
        if (result && result.length > 0 && result[0].Id > 0) {
          this.addComponent();
        } else {
          this.isSaving = false;
          this._notify.error('Failed to create system.');
        }
      },
      error: (err) => {
        this.isSaving = false;
        this._notify.error(err?.error?.Message || 'Failed to create system.');
        console.error(err);
      }
    });
  }

  private addComponent(): void {
    const request: AddComponentRequest = {
      EquipmentId: this.data.EquipmentId,
      CompartId: this.selectedCompartId,
      CompartTypeId: this.ComponentType,
      BrandId: this.SelectedMakeId,
      IsChild: this.checked,
      ParentPosition: this.parentPosition,
      ToeOut: this.selectedToeOut,
      BudgetLife: this.budgetLife,
      CMU: this.cmu,
      Cost: this.cost
      // Condition: this.selectedConditon
    };

    this._manageEquipmentService.addNewComponent(request).subscribe({
      next: (res) => {
        this.isSaving = false;
        if (res?.Status === 1) {
          this._notify.success(res.Message);
          this.dialogRef.close(true);
        } else if (res?.Status === 2) {
          this._notify.warn(res.Message);
        } else {
          this._notify.error(res.Message);
        }
      },
      error: (err) => {
        this.isSaving = false;
        this._notify.error(err?.error?.Message || 'Something went wrong while saving.');
        console.error(err);
      }
    });
  }

  getFormatedDate = (currentDate) => {
    let dd = currentDate.getDate();
    let mm = currentDate.getMonth() + 1; // January is 0!
    const yyyy = currentDate.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd} ${mm} ${yyyy}`;
  };
}